import { handleActions } from 'redux-actions-helpers'
import * as actions from './actions'
import { InitialState } from './types'

const initialState: InitialState = {
  moduleScreen: null,
  module: null,
  modules: null,
  progress: null,
  achievements: null,
  isFetching: false,
  isFetchingModule: false,
  isFetchingModulesList: false,
  isProcessUserState: false,
  achievementsIsFetching: false,
  error: '',
}

export default handleActions(
  {
    [actions.fetchModuleScreen]: state => {
      return {
        ...state,
        isFetching: true,
        error: initialState.error,
      }
    },
    [actions.fetchModuleScreenSuccess]: (state, action) => {
      return {
        ...state,
        moduleScreen: action.result,
        isFetching: false,
      }
    },
    [actions.fetchModuleScreenFailure]: (state, action) => {
      return {
        ...state,
        error: action.error,
        isFetching: false,
      }
    },
    [actions.fetchModule]: state => {
      return {
        ...state,
        isFetchingModule: true,
        error: initialState.error,
      }
    },
    [actions.fetchModuleSuccess]: (state, action) => {
      return {
        ...state,
        module: action.result,
        isFetchingModule: false,
      }
    },
    [actions.fetchModuleFailure]: (state, action) => {
      return {
        ...state,
        error: action.error,
        isFetchingModule: false,
      }
    },
    [actions.fetchModulesList]: state => {
      return {
        ...state,
        isFetchingModulesList: true,
        error: initialState.error,
      }
    },
    [actions.fetchModulesListSuccess]: (state, action) => {
      return {
        ...state,
        modules: action.result,
        isFetchingModulesList: false,
      }
    },
    [actions.fetchModulesListFailure]: (state, action) => {
      return {
        ...state,
        error: action.error,
        isFetchingModulesList: false,
      }
    },
    [actions.fetchCourseUserState]: state => {
      return {
        ...state,
        isProcessUserState: true,
      }
    },
    [actions.fetchCourseUserStateSuccess]: (state, action) => {
      return {
        ...state,
        progress: action.result,
        isProcessUserState: false,
      }
    },
    [actions.fetchCourseUserStateFailure]: (state, action) => {
      return {
        ...state,
        error: action.error,
        isProcessUserState: false,
      }
    },
    [actions.fetchAchievements]: state => {
      return {
        ...state,
        achievementsIsFetching: true,
        error: initialState.error,
      }
    },
    [actions.fetchAchievementsSuccess]: (state, action) => {
      return {
        ...state,
        achievements: action.result,
        achievementsIsFetching: false,
      }
    },
    [actions.fetchAchievementsFailure]: (state, action) => {
      return {
        ...state,
        error: action.error,
        achievementsIsFetching: false,
      }
    },
    [actions.destroy]: () => initialState,
  },
  { initialState }
)
